/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize Adherence View .
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './adherenceView';

export const mapStateToPropsAdherenceView = mapStateToProps;
export const mapDispatchToPropsAdherenceView = mapDispatchToProps;

export default connect(
  mapStateToPropsAdherenceView,
  mapDispatchToPropsAdherenceView
)(View);
